import preact from 'preact';
import {callRemoteAPI, updateLocalStorage, getLocalStorage} from '../utils/utils';
const { h, render, Component } = preact;

class CcNotificationsBadge extends Component {
	constructor() {
      super();
      this.state={
         alerts:{}
      }
      this.openNotificationPanel=this.openNotificationPanel.bind(this);
   }
	componentDidMount() {
      // listen for global event to sync badge counter by loading localStorage
      // updateNotificationsBadge gets fired when utils -> updateLocalStorage is called
      window.addEventListener('updateNotificationsBadge', ()=>this.getNotificationsFromLocalstorage(), false);
      // check for notifications in localstorage and update state accordingly
      const alerts = this.getNotificationsFromLocalstorage();
      // if we have a notification timestamp in storage call API with the timestamp to get latest notifications since timestamp
      // otherwise get all notifications from server and save all in component state and localstorage
      if(this.props.enablePollingAPI){
         this.getNotificationsFromApi(alerts ? alerts.timestamp : null);
      }
      // start polling for new notifications
      if(this.props.enablePollingAPI){
         this.polling = setInterval(()=>{
            // polling enabled only if page is visible (ie. tab is active) or if browser does not support web visibility API
            const isPageActive = (typeof(document.hidden)==='boolean') ? !document.hidden : true;
            if(isPageActive){
               // if API polling is enabled via props call notifications api with last updated timestamp
               this.getNotificationsFromApi(this.state.alerts.timestamp);
            }
         }, this.props.pollingInterval);
      }
   }
   componentWillUnmount(){
      clearInterval(this.polling);
      window.removeEventListener('updateNotificationsBadge', ()=>this.getNotificationsFromLocalstorage(), false);
   }
   getNotificationsFromLocalstorage(){
      console.log('get notifications from localstorage');
      const localData = getLocalStorage();
      const {alerts} = localData;
      if(alerts) this.setState({alerts});
      return alerts && alerts.timestamp ? alerts : null;
   }
   getNotificationsFromApi(timestamp){
      const requestURL = this.props.apiEndpoint+'?ifq-alerts-api=get-user-alerts';
      console.log('get notifications with timestamp ', timestamp, requestURL);
      /* ------------------------------------------------------------------------------------ */
      callRemoteAPI('post', requestURL, timestamp?{notifications_since:timestamp}:null, (resp)=>{
         if(!this.props.userId) return; // avoid user id errors when login is misaligned in front
         // set most recent time between local and server 
         const serverTimestamp = parseInt(resp.body.data.last_notification_tstamp,10);
         const updatedTimestamp = timestamp && (timestamp > serverTimestamp) ? timestamp : serverTimestamp;
         const {notifications, notifications_count} = resp.body.data;
         let updatedCounter, updatedNotifications;
         if(timestamp){
            console.log('adding to local notifications...');
            // add new notifications to existing local notifications
            const local = this.getNotificationsFromLocalstorage();
            updatedCounter = parseInt(local.count,10)+parseInt(notifications_count);
            updatedNotifications={
               comments:[...notifications.comments, ...local.notifications.comments],
               posts:[...notifications.posts, ...local.notifications.posts],
               users:[...notifications.users, ...local.notifications.users],
            }
         }else{
            console.log('saving new notifications...');
            updatedCounter = notifications_count;
            updatedNotifications = notifications;
         }
         const notificationsObj = {alerts:{notifications:updatedNotifications, count:updatedCounter, timestamp:updatedTimestamp}};
         // save new notifications to localstorage and update state
         updateLocalStorage(notificationsObj);
         this.setState(notificationsObj);
      }, (errorMsg)=>{
         console.error(errorMsg); // fail silently
      });
      /* ------------------------------------------------------------------------------------ */
   }
	openNotificationPanel(){
      if(this.props.clickDisabled) return;
      console.log('Open notification panel');
      // clear badge counter
      // updateLocalStorage({alerts:{...this.state.alerts, count:0}});
      this.getNotificationsFromLocalstorage(); // this will save to state
      window.openUserDetails(this.props.userId, null, true, this.props.username, 'notifications');
   }
	render(props) {
      if(this.state.alerts.count){
         return (
            <sup class="topbar-notification-badge" onClick={this.openNotificationPanel}>{this.state.alerts.count}</sup>
         )
      }
	}
}
export default CcNotificationsBadge;



// WEBPACK FOOTER //
// ./components/common/CcNotificationsBadge.js